import { Briefcase, Building2, GraduationCap } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { ROLES } from "@user-management-context/shared/domain/types/enums/roles";

export type RoleMeta = {
  label: string;
  description: string;
  Icon: LucideIcon;
};

export const ROLE_META: Record<ROLES, RoleMeta> = {
  [ROLES.STUDENT]: {
    label: "Elève",
    description: "Renseignez votre nom de scène pour accéder à votre espace de formation.",
    Icon: GraduationCap,
  },
  [ROLES.TEACHER]: {
    label: "Professeur",
    description: "Renseignez votre activité, vos coordonnées et votre facturation pour proposer des cours.",
    Icon: Briefcase,
  },
  [ROLES.PROVIDER]: {
    label: "Partenaire",
    description: "Présentez votre organisation et configurez votre espace partenaire.",
    Icon: Building2,
  },
};
